<template>
  <div class="goodsList">
    <!-- 顶部提示banner -->
    <div class="page-heading huiFilter" :style="'background-image: url('+typeData.typeImage+')'">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="textShadow">{{ typeData.typeName }}</h1>
            <span class="textShadow">{{ typeData.typeName }}-系列产品快速鉴赏</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品列表 -->
    <div class="goodsListDiv">
      <div class="simple-recent-projects projects-page filter-projects section-gap">
        <div class="container">
          <el-empty v-if="goodsList.length==0" description="分类下暂无产品哟~"></el-empty>
          <div class="row">


            <div class="col-lg-12">
              <div class="row masonry-layout filters-content normal-col-gap">
                <div @click.prevent="toGoodsDesc(item.id)" v-for="(item,index) in goodsList" :key="index" class="col-lg-4 masonry-item all category-building">
                  <div class="item">
                    <div class="project-item">
                      <div class="thumb">
                        <img :src="item.images[0]" alt="">
                        <div class="hover">
                          <div class="inner-content">
                            <div class="text-button">
                              <a style="font-size: 21px" href="project-details.html">查看详情</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="down-content">
                        <h4><a href="#">{{ item.name }}</a></h4>
                       </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'goodsList',
  data() {
    return {
      typeData:{
        typeID:null,
        typeName:null,
        typeImage:null
      },
      goodsList:[]
    }
  },
  methods:{
    // 点击跳转到产品详情
    toGoodsDesc(goodsID){
      this.$router.push({
        name:"goodsDesc",
        query:{"goodsID":goodsID}
      });
    },
    // 查询分类下的产品列表
    getGoodsList(typename){
      let _this = this;
      this.$axios.get('/fantis/goodsinfo/ftCmsGoodsInfo/list?pageNo=1&pageSize=999&typename='+typename)
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            let goodsArr = tempData.records;
            for(let i in goodsArr){

              // 如果有多张图片
              var imgArr = goodsArr[i].images.split(",");
              for(var c in imgArr){
                if(imgArr[c].startsWith('//') || imgArr[c].startsWith('https://') || imgArr[c].startsWith('http://')){

                }else{
                  imgArr[c] = _this.$fileDPath + imgArr[c];
                }
              }

              goodsArr[i].images = imgArr;

            }

            _this.goodsList = goodsArr;

          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    }
  },
  created() {
    this.typeData.typeID = this.$route.params.typeID;
    this.typeData.typeName = this.$route.params.typeName;
    this.typeData.typeImage = this.$route.params.typeImage;
    if(this.typeData.typeID == null || this.typeData.typeID == ""){
      this.typeData.typeID = "01";
      this.typeData.typeName = "五色印象";
      this.typeData.typeImage = "static/menhu/images/vantis_fan_bg.jpg";
    }
    this.getGoodsList(this.typeData.typeName);
  }
}
</script>

<style scoped>
.goodsListDiv{
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  padding: 0px 20px 0px 20px;
}
.textShadow{
  text-shadow: 2px 2px 10px dimgrey;
}

</style>



// WEBPACK FOOTER //
// src/components/views/goods/goods.vue